module.exports = __webpack_public_path__ + "static/media/operador-logo-sulamerica-dental.a2941bc5.svg";